import { _ as w } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { getAriaProps as P } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.to-string-f55666a8.js";
import M, { useRef as G } from "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { a as A } from "./index-5d0f31c6.js";
import { IconButton as B } from "./iconButton.js";
import "./es.string.small-23219181.js";
import { useTheme as ne, fpds as R } from "@ucl/shared-component-foundations";
import O from "styled-components";
import { jsx as g, jsxs as H, Fragment as te } from "react/jsx-runtime";
import "./es.string.trim-6e13db75.js";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import { g as le } from "./getMetrics-953aa4f8.js";
import { HelperText as ie } from "./helperText.js";
import { Label as oe } from "./label.js";
import "./es.object.keys-9d66766f.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./web.set-timeout-72b6430f.js";
import { uniqueId as L } from "./uniqueId.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-int-d7709701.js";
import { ScreenReaderOnly as re } from "./screenReaderOnly.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./iterate-13ada9e5.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./index-8b07dec9.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./object-to-array-0474b7e7.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./string-html-forced-a746405b.js";
import "./string-trim-14e37ad3.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./tooltip.js";
import "./es.global-this-a7f40ce1.js";
var F = 99999, W = -99999, ue = "INCREMENT_SELECTOR_INPUT_ID";
function _(n) {
  var e, l, i, o, r, c, d, t, m = ne(), a = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  };
  switch (n) {
    case "small":
      a.width = (e = m.components.incrementSelector) == null ? void 0 : e.GetIconCSS.textSize.small.width, a.height = (l = m.components.incrementSelector) == null ? void 0 : l.GetIconCSS.textSize.small.height;
      break;
    case "medium":
      a.width = (i = m.components.incrementSelector) == null ? void 0 : i.GetIconCSS.textSize.medium.width, a.height = (o = m.components.incrementSelector) == null ? void 0 : o.GetIconCSS.textSize.medium.height;
      break;
    case "large":
      a.width = (r = m.components.incrementSelector) == null ? void 0 : r.GetIconCSS.textSize.large.width, a.height = (c = m.components.incrementSelector) == null ? void 0 : c.GetIconCSS.textSize.large.height;
      break;
    default:
      a.width = (d = m.components.incrementSelector) == null ? void 0 : d.GetIconCSS.textSize.default.width, a.height = (t = m.components.incrementSelector) == null ? void 0 : t.GetIconCSS.textSize.default.height;
  }
  return a;
}
var ce = ["textSize"], me = ["textSize"], ae = ["textSize", "isDisabled", "isFullyDisabled", "children", "variant", "value", "min", "max", "onClick", "accessibilityOptions"], de = /* @__PURE__ */ O.div.withConfig({
  displayName: "stepper__Wrapper",
  componentId: "sc-1xvshjo-0"
})(["display:", ";", ";&:focus-visible{outline:", ";}"], function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.Wrapper.display;
}, function(n) {
  var e, l, i, o, r, c, d = n.textSize, t = w(n, ce);
  switch (d) {
    case "small":
      return `
          height: ` + (t == null || (e = t.theme.components.incrementSelector) == null ? void 0 : e.Wrapper.textSize.small.height) + `;
          width: ` + (t == null || (l = t.theme.components.incrementSelector) == null ? void 0 : l.Wrapper.textSize.small.width) + `;
        `;
    case "large":
      return `
          height: ` + (t == null || (i = t.theme.components.incrementSelector) == null ? void 0 : i.Wrapper.textSize.large.height) + `;
          width:` + (t == null || (o = t.theme.components.incrementSelector) == null ? void 0 : o.Wrapper.textSize.large.width) + `;
        `;
    case "medium":
    default:
      return `
          height: ` + (t == null || (r = t.theme.components.incrementSelector) == null ? void 0 : r.Wrapper.textSize.medium.height) + `;
          width: ` + (t == null || (c = t.theme.components.incrementSelector) == null ? void 0 : c.Wrapper.textSize.medium.width) + `; 
        `;
  }
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.Wrapper.focusVisible.outline;
}), se = /* @__PURE__ */ O.div.withConfig({
  displayName: "stepper__IconComponent",
  componentId: "sc-1xvshjo-1"
})(["", ";display:", ";align-items:", ";justify-content:", ";cursor:", ";position:", ";border-radius:", ";color:", ";&:hover{background-color:", ";}&:focus-visible{outline:", ";}&.disabled{cursor:", ";color:", ";&:hover{background-color:", ";}&:focus-visible{outline:", ";}}&.disabledPlusMinus{color:", ";}"], function(n) {
  var e, l, i, o, r, c, d = n.textSize, t = w(n, me);
  switch (d) {
    case "small":
      return `
          height: ` + (t == null || (e = t.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.textSize.small.height) + `;
          width: ` + (t == null || (l = t.theme.components.incrementSelector) == null ? void 0 : l.IconComponent.textSize.small.width) + `;
        `;
    case "large":
      return `
          height: ` + (t == null || (i = t.theme.components.incrementSelector) == null ? void 0 : i.IconComponent.textSize.large.height) + `;
          width:` + (t == null || (o = t.theme.components.incrementSelector) == null ? void 0 : o.IconComponent.textSize.large.width) + `;
        `;
    case "medium":
    default:
      return `
          height: ` + (t == null || (r = t.theme.components.incrementSelector) == null ? void 0 : r.IconComponent.textSize.medium.height) + `;
          width: ` + (t == null || (c = t.theme.components.incrementSelector) == null ? void 0 : c.IconComponent.textSize.medium.width) + `; 
        `;
  }
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.display;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.alignItems;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.justifyContent;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.cursor;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.position;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.borderRadius;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.color;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.hover.backgroundColor;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.focusVisible.outline;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.disabled.cursor;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.disabled.color;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.disabled.hover.backgroundColor;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.disabled.focusVisible.outline;
}, function(n) {
  var e;
  return (e = n.theme.components.incrementSelector) == null ? void 0 : e.IconComponent.disabledPlusMinus.color;
}), K = function(e) {
  var l = e.textSize, i = l === void 0 ? "medium" : l, o = e.isDisabled, r = o === void 0 ? !1 : o, c = e.isFullyDisabled, d = c === void 0 ? !1 : c, t = e.children, m = e.variant, a = e.value, s = a === void 0 ? 0 : a, p = e.min, u = p === void 0 ? W : p, v = e.max, h = v === void 0 ? F : v, S = e.onClick, b = e.accessibilityOptions, I = b === void 0 ? {} : b;
  w(e, ae);
  function C(y) {
    y.preventDefault(), y.stopPropagation(), !d && !r && (m === "subtract" && s - 1 >= u ? S == null || S(s - 1) : m === "add" && s + 1 <= h && (S == null || S(s + 1)));
  }
  return /* @__PURE__ */ g(de, {
    textSize: i,
    children: /* @__PURE__ */ g(se, Object.assign({
      onClick: C,
      onKeyDown: function(z) {
        (z.code === "Enter" || z.code === "Space") && C(z);
      },
      className: (d || r ? "disabled" : "") + " " + (r ? "disabledPlusMinus" : ""),
      textSize: i
    }, I, {
      children: t
    }))
  });
}, pe = ["textSize", "value", "isDisabled", "isFullyDisabled", "min", "accessibilityOptions"], dt = function(e) {
  var l = e.textSize, i = l === void 0 ? "medium" : l, o = e.value, r = o === void 0 ? 0 : o, c = e.isDisabled, d = c === void 0 ? !1 : c, t = e.isFullyDisabled, m = t === void 0 ? !1 : t, a = e.min, s = a === void 0 ? W : a, p = e.accessibilityOptions, u = w(e, pe), v = P("button", p), h = P("button", Object.assign({}, u["aria-label"] && {
    "aria-label": u["aria-label"]
  }, u["aria-describedby"] && {
    "aria-describedby": u["aria-describedby"]
  }, u["aria-hidden"] && {
    "aria-hidden": u["aria-hidden"]
  }, u["aria-disabled"] && {
    "aria-disabled": u["aria-disabled"]
  }));
  return /* @__PURE__ */ g(K, Object.assign({
    variant: "subtract",
    min: s,
    isFullyDisabled: m,
    isDisabled: d,
    value: r,
    textSize: i
  }, u, {
    children: /* @__PURE__ */ g(B, Object.assign({
      size: i,
      variant: "ghost",
      icon: /* @__PURE__ */ g(A, {
        icon: "subtract",
        style: _(i),
        "aria-hidden": !0
      }),
      "aria-label": "Decrement value"
    }, p, v, h, {
      disabled: d || m
    }))
  }));
}, ve = ["textSize", "value", "isFullyDisabled", "onClick", "min", "max", "htmlForId", "isRequired"], he = /* @__PURE__ */ O.input.withConfig({
  displayName: "numberInputField__InputComponent",
  componentId: "sc-179xi9o-0"
})(["display:", ";box-sizing:", ";padding:", ";justify-content:", ";align-items:", ";gap:", ";flex-shrink:", ";border-radius:", ";overflow:", ";color:", ";text-align:", ";text-overflow:", ";white-space:", ";font-style:", ";-moz-appearance:", ";border:", ";background-color:", ";&::-webkit-inner-spin-button{display:", ";}outline:", ";", ";&:hover{outline:", ";}&:focus-visible{outline:", ";}"], function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.display;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.boxSizing;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.padding;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.justifyContent;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.alignItems;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.gap;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.flexShrink;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.borderRadius;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.overflow;
}, function(n) {
  var e = n.disabled, l = n.theme;
  return e ? l.components.incrementSelector.InputComponent.color.disabled : l.components.incrementSelector.InputComponent.color.default;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.textAlign;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.textOverflow;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.whiteSpace;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.fontStyle;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.mozAppearance;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.border;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.backgroundColor;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.webkitInnerSpinButton.display;
}, function(n) {
  var e, l = n.inputState, i = n.disabled, o = n.theme;
  return !i && (o == null || (e = o.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.outline[l || "none"]);
}, function(n) {
  if (n.textSize === "small") {
    var e, l, i, o, r, c;
    return `
          min-width: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InputComponent.textSize.small.width) + `; 
          height: ` + (n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.incrementSelector) == null ? void 0 : l.InputComponent.textSize.small.height) + `; 
          font-family: ` + (n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.incrementSelector) == null ? void 0 : i.InputComponent.textSize.small.fontFamily) + `; 
          font-weight: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.incrementSelector) == null ? void 0 : o.InputComponent.textSize.small.fontWeight) + `; 
          font-size: ` + (n == null || (r = n.theme) == null || (r = r.components) == null || (r = r.incrementSelector) == null ? void 0 : r.InputComponent.textSize.small.fontSize) + `; 
          line-height: ` + (n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.incrementSelector) == null ? void 0 : c.InputComponent.textSize.small.lineHeight) + `;
      `;
  } else if (n.textSize === "medium") {
    var d, t, m, a, s, p;
    return `
        min-width:  ` + (n == null || (d = n.theme) == null || (d = d.components) == null || (d = d.incrementSelector) == null ? void 0 : d.InputComponent.textSize.medium.width) + `; 
        height:` + (n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.incrementSelector) == null ? void 0 : t.InputComponent.textSize.medium.height) + `; 
        font-family: ` + (n == null || (m = n.theme) == null || (m = m.components) == null || (m = m.incrementSelector) == null ? void 0 : m.InputComponent.textSize.medium.fontFamily) + `; 
        font-weight: ` + (n == null || (a = n.theme) == null || (a = a.components) == null || (a = a.incrementSelector) == null ? void 0 : a.InputComponent.textSize.medium.fontWeight) + `; 
        font-size: ` + (n == null || (s = n.theme) == null || (s = s.components) == null || (s = s.incrementSelector) == null ? void 0 : s.InputComponent.textSize.medium.fontSize) + `;
        line-height:  ` + (n == null || (p = n.theme) == null || (p = p.components) == null || (p = p.incrementSelector) == null ? void 0 : p.InputComponent.textSize.medium.lineHeight) + `;
      `;
  } else if (n.textSize === "large") {
    var u, v, h, S, b, I;
    return `
          min-width: ` + (n == null || (u = n.theme) == null || (u = u.components) == null || (u = u.incrementSelector) == null ? void 0 : u.InputComponent.textSize.large.width) + `;
          height:` + (n == null || (v = n.theme) == null || (v = v.components) == null || (v = v.incrementSelector) == null ? void 0 : v.InputComponent.textSize.large.height) + `;
          font-family: ` + (n == null || (h = n.theme) == null || (h = h.components) == null || (h = h.incrementSelector) == null ? void 0 : h.InputComponent.textSize.large.fontFamily) + `; 
          font-weight: ` + (n == null || (S = n.theme) == null || (S = S.components) == null || (S = S.incrementSelector) == null ? void 0 : S.InputComponent.textSize.large.fontWeight) + `; 
          font-size: ` + (n == null || (b = n.theme) == null || (b = b.components) == null || (b = b.incrementSelector) == null ? void 0 : b.InputComponent.textSize.large.fontSize) + `;
          line-height: ` + (n == null || (I = n.theme) == null || (I = I.components) == null || (I = I.incrementSelector) == null ? void 0 : I.InputComponent.textSize.large.lineHeight) + `;
      `;
  }
}, function(n) {
  var e = n.inputState, l = n.disabled, i = n.theme;
  return !l && i.components.incrementSelector.InputComponent.hover.outline[e || "none"];
}, function(n) {
  var e = n.inputState, l = n.theme;
  return l.components.incrementSelector.InputComponent.focusVisible.outline[e || "none"];
}), Se = function(e) {
  var l = e.textSize, i = l === void 0 ? "medium" : l, o = e.value, r = o === void 0 ? 0 : o, c = e.isFullyDisabled, d = c === void 0 ? !1 : c, t = e.onClick, m = e.min, a = m === void 0 ? W : m, s = e.max, p = s === void 0 ? F : s, u = e.htmlForId, v = e.isRequired, h = v === void 0 ? !1 : v, S = w(e, ve), b = M.useState(r.toString().length), I = b[0], C = b[1];
  function y(f) {
    if (f.code !== "Tab" && (r.toString().length === 1 && f.code === "Backspace" || /[^0-9-]/.test(f.key) && f.code !== "Backspace" && f.code !== "ArrowLeft" && f.code !== "ArrowRight"))
      return f.stopPropagation(), f.preventDefault(), !1;
  }
  function z(f) {
    if (!d) {
      var $ = parseInt(f.currentTarget.value);
      $ < a || $ > p || isNaN($) ? t == null || t(r) : t == null || t($);
    }
    C(f.currentTarget.value.length);
  }
  return /* @__PURE__ */ H(te, {
    children: [/* @__PURE__ */ g(he, Object.assign({
      "aria-labelledby": U + "_label_id",
      textSize: i,
      type: "number",
      value: r,
      onKeyDown: y,
      onChange: z,
      disabled: d,
      "aria-required": h
    }, S, {
      id: u,
      style: {
        width: "calc(" + I + "ch + " + R.semantic.space["1x"] + " + " + R.semantic.space["1x"] + " + " + R.semantic.space["1x"] + ")"
      }
    })), /* @__PURE__ */ g(re, {
      "aria-live": "assertive",
      children: r
    })]
  });
}, be = /* @__PURE__ */ function(n) {
  return n.ERROR = "error", n.NONE = "none", n;
}({}), fe = ["value", "textSize", "isDisabled", "onChange", "children", "min", "max", "htmlForId", "labelProp", "infoProp", "trailingText", "showRequiredIndicator", "inputState", "helperTextProp"], ge = /* @__PURE__ */ O.div.withConfig({
  displayName: "incrementSelector__OuterWrapper",
  componentId: "gmztsw-0"
})(["display:", ";flex-direction:", ";gap:", ";"], function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.OuterWrapper.display;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.OuterWrapper.flexDirection;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.OuterWrapper.gap;
}), Ie = /* @__PURE__ */ O.div.withConfig({
  displayName: "incrementSelector__InnerWrapper",
  componentId: "gmztsw-1"
})(["border-radius:", ";position:", ";align-items:", ";justify-content:", ";box-sizing:", ";padding:", ";display:", ";gap:", ";", " ", " width:fit-content;"], function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.borderRadius;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.position;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.alignItems;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.justifyContent;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.boxSizing;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.padding;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.display;
}, function(n) {
  var e;
  return n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.incrementSelector) == null ? void 0 : e.InnerWrapper.gap;
}, function(n) {
  var e, l;
  return `
      background-color: ` + ((e = n.theme.components.incrementSelector) == null ? void 0 : e.InnerWrapper.backgroundColor) + `;
      border: ` + (n == null || (l = n.theme.components) == null || (l = l.incrementSelector) == null ? void 0 : l.InnerWrapper.border) + `;
      `;
}, function(n) {
  var e, l, i;
  switch (n.textSize) {
    case "small":
      return `
          height: ` + (n == null || (e = n.theme.components.incrementSelector) == null ? void 0 : e.InnerWrapper.textSize.small.height) + `;
        `;
    case "large":
      return `
          height: ` + (n == null || (l = n.theme.components.incrementSelector) == null ? void 0 : l.InnerWrapper.textSize.large.height) + `;
        `;
    case "medium":
    default:
      return `
          height: ` + (n == null || (i = n.theme.components.incrementSelector) == null ? void 0 : i.InnerWrapper.textSize.medium.height) + `; 
        `;
  }
}), U = "UCL_IncrementSelector", st = function(e) {
  var l, i, o, r, c, d = e.value, t = e.textSize, m = t === void 0 ? "medium" : t, a = e.isDisabled, s = a === void 0 ? !1 : a, p = e.onChange, u = e.children, v = u === void 0 ? [] : u, h = e.min, S = h === void 0 ? W : h, b = e.max, I = b === void 0 ? F : b, C = e.htmlForId, y = e.labelProp, z = e.infoProp, f = e.trailingText, $ = e.showRequiredIndicator, V = $ === void 0 ? !1 : $, X = e.inputState, x = e.helperTextProp, J = w(e, fe), Q = le({
    label: "IncrementSelector"
  }), T = G(L(U)), j = G(L(ue)), N = T.current + "_label_id", E = X || be.NONE, D = {
    defaultId: (x == null || (l = x.defaultProp) == null ? void 0 : l.id) || "default_" + T.current + "_message_id",
    secondaryId: (x == null || (i = x.secondaryProp) == null ? void 0 : i.id) || "secondary_" + T.current + "_message_id"
  }, Y = !!(x != null && (o = x.defaultProp) != null && (o = o.helperText) != null && o.trim().length), Z = !!(x != null && (r = x.secondaryProp) != null && (r = r.helperText) != null && r.trim().length), k = y != null && y.label ? N : "";
  return Y && (k += " " + (D == null ? void 0 : D.defaultId)), Z && (k += " " + (D == null ? void 0 : D.secondaryId)), /* @__PURE__ */ H(ge, Object.assign({}, J, Q, {
    children: [/* @__PURE__ */ g(oe, {
      labelProp: Object.assign({
        showRequiredIndicator: V,
        id: N,
        htmlFor: C || j.current
      }, y),
      infoProp: Object.assign({
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Info"
      }, z),
      trailingText: f
    }), /* @__PURE__ */ g(Ie, {
      isDisabled: s,
      textSize: m,
      children: v.map(function(q, ee) {
        return /* @__PURE__ */ M.cloneElement(q, {
          textSize: m,
          onClick: p,
          value: d,
          isFullyDisabled: s,
          inputState: E,
          htmlForId: C || j.current,
          min: S,
          max: I,
          "aria-labelledby": q.type === Se ? k : void 0,
          key: "increment-selector-child-" + ee
        });
      })
    }), /* @__PURE__ */ g(ie, {
      "data-testid": "helper-text_test",
      inputState: E,
      defaultProp: {
        id: D.defaultId,
        helperText: (x == null || (c = x.defaultProp) == null ? void 0 : c.helperText) || ""
      },
      secondaryProp: Object.assign({
        id: D.secondaryId
      }, x == null ? void 0 : x.secondaryProp)
    })]
  }));
}, xe = ["textSize", "value", "isDisabled", "isFullyDisabled", "max", "accessibilityOptions"], pt = function(e) {
  var l = e.textSize, i = l === void 0 ? "medium" : l, o = e.value, r = o === void 0 ? 0 : o, c = e.isDisabled, d = c === void 0 ? !1 : c, t = e.isFullyDisabled, m = t === void 0 ? !1 : t, a = e.max, s = a === void 0 ? F : a, p = e.accessibilityOptions, u = w(e, xe), v = P("button", p), h = P("button", Object.assign({}, u["aria-label"] && {
    "aria-label": u["aria-label"]
  }, u["aria-describedby"] && {
    "aria-describedby": u["aria-describedby"]
  }, u["aria-hidden"] && {
    "aria-hidden": u["aria-hidden"]
  }, u["aria-disabled"] && {
    "aria-disabled": u["aria-disabled"]
  }));
  return /* @__PURE__ */ g(K, Object.assign({
    variant: "add",
    max: s,
    isFullyDisabled: m,
    isDisabled: d,
    value: r,
    textSize: i
  }, u, {
    children: /* @__PURE__ */ g(B, Object.assign({
      size: i,
      variant: "ghost",
      icon: /* @__PURE__ */ g(A, {
        icon: "add",
        style: _(i),
        "aria-hidden": !0
      }),
      disabled: d || m,
      "aria-label": "Increment value"
    }, p, v, h))
  }));
};
export {
  dt as DecrementStepper,
  st as IncrementSelector,
  pt as IncrementStepper,
  Se as NumberInputField
};
